import { createApi } from '@reduxjs/toolkit/query/react';

import {
  PositionsEndpoints as Endpoints,
  type GetPositionByIdRequest,
  type GetPositionByIdResponse,
  type GetPositionRolesRequest,
  type GetPositionRolesResponse,
  type GetPositionsByOrganizationIdRequest,
  type GetPositionsByOrganizationIdResponse,
  type GetPositionsForSystemRequest,
  type GetPositionsForSystemResponse,
  type GetPositionsRequest,
  type GetPositionsResponse,
  type UpdatePositionRequest,
  type UpdatePositionResponse,
} from '@app/api/Positions/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { POSITIONS_CHUNK } from '@app/constants';

export const positionsApi2 = createApi({
  reducerPath: 'positionsApi2',
  baseQuery: createApiBaseQuery(POSITIONS_CHUNK),
  endpoints: ({ query, mutation }) => ({
    [Endpoints.UpdatePosition]: mutation<
      UpdatePositionResponse,
      UpdatePositionRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.UpdatePosition,
        method: Methods.POST,
        params,
        data,
      }),
    }),
    [Endpoints.GetPositionById]: query<
      GetPositionByIdResponse,
      GetPositionByIdRequest
    >({
      query: (params) => ({
        url: Endpoints.GetPositionById,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetPositions]: query<GetPositionsResponse, GetPositionsRequest>({
      query: (params) => ({
        url: Endpoints.GetPositions,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetPositionsForSystem]: query<
      GetPositionsForSystemResponse,
      GetPositionsForSystemRequest
    >({
      query: (params) => ({
        url: Endpoints.GetPositionsForSystem,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetPositionsByOrganizationId]: query<
      GetPositionsByOrganizationIdResponse,
      GetPositionsByOrganizationIdRequest
    >({
      query: (params) => ({
        url: Endpoints.GetPositionsByOrganizationId,
        method: Methods.GET,
        params,
      }),
    }),
    [Endpoints.GetPositionRoles]: query<
      GetPositionRolesResponse,
      GetPositionRolesRequest
    >({
      query: (params) => ({
        url: Endpoints.GetPositionRoles,
        method: Methods.GET,
        params,
      }),
    }),
  }),
});

export const {
  useUpdatePositionMutation,
  useGetPositionByIdQuery,
  useLazyGetPositionByIdQuery,
  useGetPositionsQuery,
  useLazyGetPositionsQuery,
  useGetPositionsForSystemQuery,
  useLazyGetPositionsForSystemQuery,
  useGetPositionsByOrganizationIdQuery,
  useLazyGetPositionsByOrganizationIdQuery,
  useGetPositionRolesQuery,
  useLazyGetPositionRolesQuery,
} = positionsApi2;
